import { render, staticRenderFns } from "./LoaderRelative.vue?vue&type=template&id=9d755c30&"
import script from "./LoaderRelative.vue?vue&type=script&lang=js&"
export * from "./LoaderRelative.vue?vue&type=script&lang=js&"
import style0 from "./LoaderRelative.vue?vue&type=style&index=0&id=9d755c30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports